import { render, staticRenderFns } from "./baseTag.vue?vue&type=template&id=3fb015a0&scoped=true&"
import script from "./baseTag.vue?vue&type=script&lang=js&"
export * from "./baseTag.vue?vue&type=script&lang=js&"
import style0 from "./baseTag.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./baseTag.vue?vue&type=style&index=1&id=3fb015a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb015a0",
  null
  
)

component.options.__file = "baseTag.vue"
export default component.exports